import { create } from "zustand";

type State = {
  open: boolean;
  setOpen: () => void;
  setClose: () => void;
};

export const useSidebar = create<State>()((set) => ({
  open: false,
  setOpen: () => set({ open: true }),
  setClose: () => set({ open: false }),
}));
